<template>
  <router-view class="admins" />
</template>

<script>
export default {
  name: 'adminsIndex'
}
</script>

<style scoped lang="scss">
.admins {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
